<template>
    <el-dialog class="resource--portrait-detail-dialog" :visible.sync="visible" :close-on-click-modal="false" :before-close="close" width="835px" :title="basicData.supplierNameCn" top="8vh">
        <div v-loading="loading">
            <el-row>
                <el-col :span="18" style="padding-left: 32px;">
                    <el-row>
                        <el-col :span="12">
                            <div class="portrait-basic"><span class="portrait-label">联系人：</span><span class="portrait-data">{{ basicData.contacts }}</span></div>
                        </el-col>
                        <el-col :span="12">
                            <div class="portrait-basic"><span class="portrait-label">合作类型：</span><span class="portrait-data">{{ basicData.cooperationType_ }}</span></div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">注册资金：</span>
                                <span class="portrait-data" v-if="basicData.registerCapital">{{ basicData.registerCapital }}万</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">与安得合作年限：</span>
                                <span class="portrait-data" v-if="basicData.cooperationPeriod">{{ basicData.cooperationPeriod }}年</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">联系方式：</span>
                                <span class="portrait-data">{{ basicData.contactsMobile }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">合作分公司数：</span>
                                <span class="portrait-data">{{ basicData.cooperateBranchOfficeNum }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">承运商类型：</span>
                                <span class="portrait-data">{{ basicData.transType_ }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">生效合同数：</span>
                                <span class="portrait-data">{{ basicData.effectContractNumber }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">运输模式：</span>
                                <span class="portrait-data">{{ basicData.transportationMode_ }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label question-label">合同保证金（万）：</span>
                                <span class="portrait-data">{{ basicData.depositAmountTotal }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">引入分公司：</span>
                                <span class="portrait-data">{{ basicData.companyName }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="portrait-basic">
                                <span class="portrait-label">是否基地供应商：</span>
                                <span class="portrait-data">{{ basicData.basicLogistics_ }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="portrait-basic"><span class="portrait-label">注册地址：</span><span class="portrait-data">{{ basicData.address }}</span></div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="6" class="portrait-img-col">
                    <div class="portrait-img-wrap">
                        <img :src="rank[basicData.supplierRate]" alt="">
                    </div>
                    <div class="portrait-rank-txt">供应商评级</div>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <div class="risk-wrap">
                        <img class="icon" src="./imgs/icon1.png" alt="">
                        <div class="label">天眼查风险</div>
                        <div class="risk-box">
                            <div class="risk-item">
                                <div>被执行人</div>
                                <div class="value">{{basicData.zhiXingInfoNumber}}</div>
                            </div>
                            <div class="risk-item">
                                <div>限制消费令</div>
                                <div class="value">{{basicData.consumptionNumber}}</div>
                            </div>
                            <div class="risk-item">
                                <div>法律诉讼</div>
                                <div class="value">{{basicData.lawSuitInfoNumber}}</div>
                            </div>
                            <div class="risk-item">
                                <div>失信人</div>
                                <div class="value">{{basicData.dishonestInfoNumber}}</div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div class="green-box">
                <el-row>
                    <el-col :span="16" style="border-right: 1px solid #C1C1C1;">
                        <div class="title">
                            <img class="icon" src="./imgs/icon2.png" alt="">
                            <div class="label">能力展示</div>
                        </div>
                        <el-row>
                            <el-col :span="12">
                                <div class="portrait-basic">
                                    <span class="portrait-label">自有车数量：</span>
                                    <span class="portrait-data">{{ basicData.selfOwnCarNum }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="portrait-basic">
                                    <span class="portrait-label">自有车运作占比
                                        <el-tooltip class="item" effect="dark" placement="top" :content="'前3个月的自有车CP单（ 不含本月）÷前3个月的CP单（不含本月）×100%'">
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    ：</span>
                                    <span class="portrait-data" v-if="basicData.ownDepartureTimeProportion !== null">{{ basicData.ownDepartureTimeProportion }}%</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div class="portrait-basic">
                                    <span class="portrait-label">优势车型
                                        <el-tooltip class="item" effect="dark" placement="top" :content="'前三个月发车CP单≥30的车型，取CP单排名前三的车型。（统计前三个月不含当月数据，不满足前三个月发车CP单≥30的车型展示为空）'">
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    ：</span>
                                    <span class="portrait-data">{{ basicData.advantageLengthName }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="portrait-basic">
                                    <span class="portrait-label">稳定合作车辆数
                                        <el-tooltip class="item" effect="dark" placement="top" :content="'前三个月发车总CP单≥3的车辆数，统计前三个月不含当月数据，大数据计算后提供数据'">
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    ：</span>
                                    <span class="portrait-data">{{ basicData.cooperativeStableNum }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div class="portrait-basic">
                                    <span class="portrait-label">优势行业
                                        <el-tooltip class="item" effect="dark" placement="top" :content="'前三个月发车趟次≥60，取CP单排名前三的行业，（统计前三个月不含当月数据，不满足前三个月发车CP单≥60的行业展示为空）'">
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                        ：</span>
                                    <span class="portrait-data">{{ basicData.advantageIndustryName }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="portrait-basic">
                                    <span class="portrait-label">客户系：</span>
                                    <span class="portrait-data ellipsis">{{ basicData.customerGroupCode_ }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="portrait-basic"><span class="portrait-label">拥有车辆能源类型：</span><span class="portrait-data">油车{{ basicData.oilCarNumber||0 }}/新能源{{ basicData.newEnergyVehicleNumber||0 }}/LNG车{{ basicData.lngCarNumber||0 }}</span></div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="portrait-basic" style="margin-bottom: 0;">
                                    <span class="portrait-label">优势线路
                                        <el-tooltip class="item" effect="dark" placement="top" :content="'按照实际承运线路省-省的维度，前3个月该线路发车趟次≥30趟，发车趟次排名前3的线路（按线路维度）'">
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                        ：</span>
                                    <span class="portrait-data">{{ basicData.advantageLines || '' }}</span>
                                    <!-- <span class="portrait-data">{{ (basicData.advantageTransportRecordList||[]).join('，') }}</span> -->
                            </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="8" style="padding-left: 30px;">
                        <div class="title">
                            <img class="icon" src="./imgs/icon3.png" alt="">
                            <div class="label">运作质量</div>
                        </div>
                        <el-row>
                            <el-col :span="24">
                                <div class="portrait-basic">
                                    <span class="portrait-label">发车及时率（%）：</span>
                                    <span class="portrait-data">{{ basicData.assessmentDefCode1 }}</span>
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="portrait-basic">
                                    <span class="portrait-label">到车及时率（%）：</span>
                                    <span class="portrait-data">{{ basicData.assessmentDefCode2 }}</span>
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="portrait-basic">
                                    <span class="portrait-label">在途可视率（%）：</span>
                                    <span class="portrait-data">{{ basicData.onWayTransportRate }}</span>
                                    <!-- <span class="portrait-data">-</span> -->
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import imgA from './imgs/A.png';
import imgB from './imgs/B.png';
import imgC from './imgs/C.png';
import imgD from './imgs/D.png';
import { dictWithUrl } from '@/components/lots/api';
import { transportPortraitRateDetail } from '../../../api/transportPortrait.js';

export default {
    name: 'portraitDetailDialog',
    components: { },
    data() {
        return {
            dict: {},
            visible: false,
            loading: false,
            basicData: {},
            rank: { // SRM_SUPPLIER_RATE
                '1': imgA,
                '2': imgB,
                '3': imgC,
                '4': imgD
            }
        };
    },
    created(){
        dictWithUrl('SRM_COOPERATION_TYPE,SRM_SHIPPER_TYPE,SRM_TRANSPORTATION_MODE,SYS_CUST_RELATION_TYPE,SRM_YES_OR_NO').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
            }
        });
    },
    methods: {
        close() {
            this.visible = false;
        },
        open(row) {
            this.loading = true
            transportPortraitRateDetail({supplierCode: row.supplierCode, businessType: row.businessType}).then(res => {
                if (res && +res.code === 0) {
                    this.basicData = res.data || {}
                    this.$set(this.basicData, 'basicLogistics_', this.dict.SRM_YES_OR_NO[this.basicData.basicLogistics]);
                    this.$set(this.basicData, 'cooperationType_', this.dict.SRM_COOPERATION_TYPE[this.basicData.cooperationType]);
                    this.$set(this.basicData, 'transType_', this.dict.SRM_SHIPPER_TYPE[this.basicData.transType]);
                    this.$set(this.basicData, 'transportationMode_', this.dict.SRM_TRANSPORTATION_MODE[this.basicData.transportationMode]);
                    this.$set(this.basicData, 'customerGroupCode_', (this.basicData.customerGroupCode||'').split(',').map(v => this.dict.SYS_CUST_RELATION_TYPE[v]).join('/'));
                }
            }).finally(() => {
                this.loading = false
            })
            this.visible = true;
        },
    }
};
</script>
<style lang="less">
.resource--portrait-detail-dialog {
    .el-dialog {
        border-radius: 8px;
    }

    .el-dialog__header {
        border-bottom: 1px solid #e6e6e6 !important;

        .el-dialog__title{
            font-size: 20px;
            font-weight: 600;
        }
    }

    .el-dialog__body {
        padding: 20px 20px 36px;
    }


    .portrait-basic {
        display: flex;
        margin-right: 20px;
        margin-bottom: 16px;
        font-size: 15px;
    }

    i[class|="el-icon"] {
        display: inline-block;
        // color: #00A9AC;
    }

    .portrait-label {
        font-size: 12px;
        color: #666;
        flex: 0 0 120px;
    }
    .portrait-data {
        font-size: 12px;
        color: #000;
        font-weight: 500;

        &.ellipsis{
            display: -webkit-box;             
            -webkit-box-orient: vertical;     
            -webkit-line-clamp: 2;            
            overflow: hidden;                 
        }
    }

    .portrait-img-col {
        text-align: center;
    }

    .portrait-img-wrap img {
        width: 111px;
        height: 168px;
    }

    .portrait-rank-txt {
        font-size: 15px;
        color: #000;
        font-weight: 500;
        line-height: 28px;
    }


    .portrait-sub-title {
        padding-left: 10px;
        margin-bottom: 24px;
        font-size: 20px;
        color: #000;
        border-left: 4px solid #00A9AC;
    }

    span.portrait-select {
        padding: 4px 8px;
        margin-right: 8px;
        color: #00A9AC;
        background: #00A9AC19;
        border-radius: 4px;
    }

    .risk-wrap{
        display: flex;
        align-items: center;

        .icon{
            width: 20px;
            height: 20px;
        }

        .label{
            margin: 0 12px;
            font-size: 16px;
            color: #000;
            font-weight: 600;
        }

        .risk-box{
            flex: 1;
            display: flex;
            align-items: center;

            .risk-item{
                padding: 6px 0 2px;
                height: 40px;
                font-size: 12px;
                text-align: center;
                color: #666;
                background: #FBF1F1;
                box-sizing: border-box;
                flex: 1;

                .value{
                    color: #F56C6C;
                }

                &:first-child{
                    background: rgba(255, 182, 182, .5);

                    .value{
                        color: #666;
                    }
                }
            }
        }
    }

    .green-box{
        padding: 10px 32px;
        margin-top: 10px;
        background: #F1FAFB;

        .title{
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .icon{
                margin-right: 10px;
                width: 20px;
                height: 20px;
            }

            .label{
                font-size: 16px;
                font-weight: 600;
                color: #000;
            }
        }
    }
}
</style>